import * as Sentry from "@sentry/browser";

export function logError(e: any) {
  Sentry.withScope(function (scope) {
    //scope.setTag("my-tag", "my value");
    scope.setLevel("error");
    // will be tagged with my-tag="my value"
    Sentry.setExtra("error", e);
    Sentry.captureException(e);
  });

  console.error(e);
}
